import React, { useEffect, useState } from 'react';

// Utils
import { getTranslateByKey } from '@/main/services/utils';

// Models
import { AddressByBodyshopResponse } from '@/main/models/response';

// Components
import ContainerBox from '../../../components/containerBox/containerBox';
import LoadingComponent from '@/main/components/shared/loading/loadingComponent';
import KogRadioGroupComponent, {
  IOptionGridRadio
} from '@/main/components/shared/radioButton/radioGroupComponent';

// Styles
import * as S from '../styles';
import { AddressTypeEnum } from '@/main/services/enum/AddressTypeEnum';
import { firstElementList } from '@/main/services/utilsArray';
import { useCreateOrderContext } from '../../../context';

interface IDeliveryAddress {
  isBillingAddress?: boolean;
  addressData: AddressByBodyshopResponse[] | null;
  optionsSelectedDeliveryAddress: string | null;
  setOptionsSelectedDeliveryAddress: React.Dispatch<
    React.SetStateAction<string | null>
  >;
  hasItemsOfCarts: boolean;
  label: string;
  isLoading: boolean;

  guidAddressSaved: string | null;
  integration: boolean;
  isQuoteOpen: boolean;
  isQuoteManual: boolean;
  isQuoteCanceled?: boolean;
}
function BillingOrDeliveryAddress({
  isBillingAddress,
  addressData,
  optionsSelectedDeliveryAddress,
  setOptionsSelectedDeliveryAddress,
  hasItemsOfCarts,
  label,
  isLoading,
  guidAddressSaved,
  integration,
  isQuoteOpen,
  isQuoteManual,
  isQuoteCanceled = false
}: IDeliveryAddress) {
  const [optionsDeliveryAddress, setOptionsDeliveryAddress] = useState<
    IOptionGridRadio[]
  >([]);
  const {
    isQuoteBlocked,
  } = useCreateOrderContext();

  useEffect(() => {
    if (addressData) {
      const formattedOptionsAddress = addressData.map(
        (option: AddressByBodyshopResponse) => {
          const idForTestsValue = `id-createOrder-radio-${option.street}-${option.municipality.zipCode}`;
          return {
            id: option.guid,
            elements: [
              {
                content: (
                  <div style={{ display: 'flex', flexDirection: 'column' }}>
                    <span>
                      {option.street}
                      {option.number ? ` - ${option.number}` : ''}
                    </span>
                    <span>
                      {option.municipality.name}, &nbsp;
                      {option.municipality.city.name}, &nbsp;
                      {option.municipality.city.state.name} -&nbsp;
                      {option.municipality.zipCode}
                    </span>
                  </div>
                ),
                width: '35%'
              },
              {
                content: (
                  <div style={{ display: 'flex', flexDirection: 'column' }}>
                    <p
                      style={{
                        marginBottom: '0px'
                      }}>
                      {getTranslateByKey('information.complement')}
                    </p>
                    <p
                      style={{
                        marginBottom: '0px',
                        width: '100%',
                        overflowWrap: 'break-word'
                      }}>
                      {option.complement}
                    </p>
                  </div>
                ),
                width: '40%'
              }
            ],
            idForTests: idForTestsValue
          };
        }
      ) as IOptionGridRadio[];
      setOptionsDeliveryAddress(formattedOptionsAddress);

      // Pre-select by default
      if (!isBillingAddress) {
        let findAddress = null;
        if (guidAddressSaved) {
          findAddress = addressData.find(
            address => address.guid === guidAddressSaved
          );
        } else {
          findAddress = addressData.find(address => address.delivery);
        }

        setOptionsSelectedDeliveryAddress(findAddress?.guid || null);
      } else {
        const addressBilling = addressData.find(
          address => Number(address.idAddressType) === AddressTypeEnum.Billing
        );
        if (addressBilling) {
          setOptionsSelectedDeliveryAddress(addressBilling.guid);
        } else {
          // Notation: If there is no billing address, take the first address from the list
          const address = firstElementList(addressData);
          if (address) {
            setOptionsSelectedDeliveryAddress(address.guid);
          }
        }
      }
    } else {
      setOptionsDeliveryAddress([]);
      setOptionsSelectedDeliveryAddress(null);
    }
  }, [addressData]);

  function disabledRadioGroup() {
    if (hasItemsOfCarts || isQuoteCanceled || isQuoteBlocked) {
      return true;
    }

    if (integration) {
      if (isQuoteOpen || isQuoteManual) {
        return true;
      }
    }

    return false;
  }

  if (isLoading) {
    return <LoadingComponent />;
  }

  return (
    <>
      {optionsDeliveryAddress.length !== 0 && (
        <ContainerBox title={label}>
          <S.RowRadio>
            <KogRadioGroupComponent
              nameCustom="deliveryAddress"
              options={optionsDeliveryAddress}
              optionsSelected={optionsSelectedDeliveryAddress}
              setOptionsSelected={setOptionsSelectedDeliveryAddress}
              disabled={disabledRadioGroup()}
            />
          </S.RowRadio>
        </ContainerBox>
      )}
    </>
  );
}

export default BillingOrDeliveryAddress;
